// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nsbdw","top":"styles_top__1MKea"};